import { ValidatedWorkClaimProps } from 'types';

export const makeNewWorkPeriod = (
  candidate_id: number,
): ValidatedWorkClaimProps => {
  return {
    employment_details: '',
    employment_details_other: '',
    contract_additional_information: '',
    cage_number: '',
    job_title: null,
    employer_provided_date_of_birth: null,
    contract_complete: null,
    open: true,
    contract_id: null,
    subcontract_details: null,
    badge_id: null,
    job_location: 'AF',
    full_part_time: null,
    reason_for_separation: null,
    contract_supervisor_given_name: null,
    contract_supervisor_surname: null,
    contract_supervisor_email: null,
    validated_work_claim_start_date: null,
    validated_work_claim_end_date: null,
    ready_for_admin_approval: false,
    candidate_id: candidate_id,
    organization_id: null,
    id: null,
  };
};
